import { BaseNomenclature } from "./baseNomenclature.model";

export class DosimeterState extends BaseNomenclature {
    prerequisite: String;
    constructor(){
        super();
        this.prerequisite="";
        this.collection_name="dosimeter_states";
    }
}